/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkUpdateEscalationTicketsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {BulkUpdateEscalationTicketsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const bulkUpdateEscalationTickets = (request: BulkUpdateEscalationTicketsRequest, options?: CashRequestOptions) => post<BulkUpdateEscalationTicketsRequest, BulkUpdateEscalationTicketsResponse>("/2.0/cash/bulk-update-escalation-tickets", request, {...options, rejectOnError: true })